import { isNonNullable } from '@ori/ts-utils';
export const mapShade = ({
  colorHexCode,
  colorImageUrl,
  productCode,
  shadeName,
  hexColors
}) => {
  const props = {
    productCode: productCode ?? '',
    hexColors: hexColors ? hexColors.filter(isNonNullable) : undefined
  };
  if (colorHexCode && (hexColors?.length ?? 0) === 0) {
    props.hexColors = colorHexCode.split(',');
  }
  if (colorImageUrl) {
    props.imageUrl = colorImageUrl;
  }
  if (shadeName) {
    props.shadeName = shadeName;
  }
  return props;
};
//# sourceMappingURL=mapShade.js.map